"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/bid/tender");
const actionTypes_1 = require("../../modules/files/list/actionTypes");
const _metaReducers = require("../../modules/metaschema/reducers");
const _previewReducer = require("../../modules/files/preview/reducers");
const metaReducers = _metaReducers.default('tender-documents');
const fileActionTypes = (0, actionTypes_1.default)('tender-documents');
const previewReducer = _previewReducer.default('tender-documents');
exports.initialState = {
    metaSchema: Object.assign({}, metaReducers.initialState),
    preview: previewReducer.initialState,
    status: 'STANDBY',
    participant: null,
    submitted: null,
    companyInfo: {
        originalBusinessId: null,
        originalCompany: null,
        changedBusinessId: null,
        changedCompany: null,
        hasApproved: false
    },
    reliablePartnerStatusCheck: {
        value: 'UNKNOWN',
        lastCheckedAt: 0,
        updatedAt: 0,
        isStatusChanged: undefined,
        participantUuid: ''
    },
    documents: {
        tenderStatus: 'STANDBY',
        tender: [],
        uploadedTenderStatus: 'STANDBY',
        uploadedTender: [],
        removedTender: [],
        suitabilityStatus: 'STANDBY',
        suitability: [],
        uploadedSuitabilityStatus: 'STANDBY',
        uploadedSuitability: [],
        removedSuitability: [],
        requestToParticipantStatus: 'STANDBY',
        requestToParticipant: [],
        reliablePartnerFetchStatus: 'STANDBY',
        reliablePartner: [],
        selectedDocuments: []
    },
    notes: [],
    listNotesStatus: 'STANDBY',
    addNoteStatus: 'STANDBY',
    editNoteStatus: 'STANDBY',
    submitStatus: 'STANDBY',
    approveStatus: 'STANDBY',
    declineStatus: 'STANDBY',
    isModalOpen: false,
    reliablePartnerStatusUpdateFailure: {
        error: { type: '', message: '' },
        participantUuid: ''
    },
    reliablePartnerReportFetchStatus: {
        reportStatus: 'STANDBY',
        participantUuid: ''
    }
};
const previewLens = monocle.Lens.fromProp('preview');
const statusLens = monocle.Lens.fromProp('status');
const participantLens = monocle.Lens.fromProp('participant');
const submittedLens = monocle.Lens.fromProp('submitted');
const partnerStatusValueLens = monocle.Lens.fromPath(['reliablePartnerStatusCheck', 'value']);
const partnerStatusLastCheckedAtLens = monocle.Lens.fromPath(['reliablePartnerStatusCheck', 'lastCheckedAt']);
const partnerStatusUpdatedAt = monocle.Lens.fromPath(['reliablePartnerStatusCheck', 'updatedAt']);
const statusUpdateFailureLens = monocle.Lens.fromPath(['reliablePartnerStatusUpdateFailure', 'error']);
const isStatusChangedLens = monocle.Lens.fromPath(['reliablePartnerStatusCheck', 'isStatusChanged']);
const participantUuidLens = monocle.Lens.fromPath(['reliablePartnerStatusCheck', 'participantUuid']);
const originalCompanyLens = monocle.Lens.fromPath(['companyInfo', 'originalCompany']);
const originalBusinessIdLens = monocle.Lens.fromPath(['companyInfo', 'originalBusinessId']);
const changedCompanyLens = monocle.Lens.fromPath(['companyInfo', 'changedCompany']);
const changedBusinessIdLens = monocle.Lens.fromPath(['companyInfo', 'changedBusinessId']);
const hasApprovedLens = monocle.Lens.fromPath(['companyInfo', 'hasApproved']);
const documentsLens = monocle.Lens.fromProp('documents');
const tenderStatusLens = monocle.Lens.fromProp('tenderStatus');
const tenderRootLens = monocle.Lens.fromProp('tenderRoot');
const tenderLens = monocle.Lens.fromProp('tender');
const uploadedTenderStatusLens = monocle.Lens.fromProp('uploadedTenderStatus');
const uploadedTenderLens = monocle.Lens.fromProp('uploadedTender');
const removedTenderLens = monocle.Lens.fromProp('removedTender');
const suitabilityStatusLens = monocle.Lens.fromProp('suitabilityStatus');
const suitabilityRootLens = monocle.Lens.fromProp('suitabilityRoot');
const suitabilityLens = monocle.Lens.fromProp('suitability');
const uploadedSuitabilityStatusLens = monocle.Lens.fromProp('uploadedSuitabilityStatus');
const uploadedSuitabilityLens = monocle.Lens.fromProp('uploadedSuitability');
const removedSuitabilityLens = monocle.Lens.fromProp('removedSuitability');
const requestToParticipantStatusLens = monocle.Lens.fromProp('requestToParticipantStatus');
const requestToParticipantRootLens = monocle.Lens.fromProp('requestToParticipantRoot');
const requestToParticipantLens = monocle.Lens.fromProp('requestToParticipant');
const reliablePartnerFetchStatusLens = monocle.Lens.fromProp('reliablePartnerFetchStatus');
const reliablePartnerRootLens = monocle.Lens.fromProp('reliablePartnerRoot');
const reliablePartnerLens = monocle.Lens.fromProp('reliablePartner');
const selectedDocumentsLens = monocle.Lens.fromProp('selectedDocuments');
const submitStatusLens = monocle.Lens.fromProp('submitStatus');
const notesLens = monocle.Lens.fromProp('notes');
const listNotesStatusLens = monocle.Lens.fromProp('listNotesStatus');
const addNoteStatusLens = monocle.Lens.fromProp('addNoteStatus');
const editNoteStatusLens = monocle.Lens.fromProp('editNoteStatus');
const metaSchemaLens = monocle.Lens.fromProp('metaSchema');
const approveStatusLens = monocle.Lens.fromProp('approveStatus');
const declineStatusLens = monocle.Lens.fromProp('declineStatus');
const isModalOpenLens = monocle.Lens.fromProp('isModalOpen');
const reportFetchStatusLens = monocle.Lens.fromPath(['reliablePartnerReportFetchStatus', 'reportStatus']);
const reportParticipantUuidLens = monocle.Lens.fromPath(['reliablePartnerReportFetchStatus', 'participantUuid']);
exports.methods = Object.keys(metaReducers.methods).reduce((acc, method) => {
    acc[method] = (state, action) => metaSchemaLens.modify((metaState) => metaReducers.methods[method](metaState, action))(state);
    return acc;
}, Object.keys(previewReducer.methods).reduce((acc, method) => {
    acc[method] = (state, action) => previewLens.modify((previewState) => previewReducer.methods[method](previewState, action))(state);
    return acc;
}, {}));
exports.methods[ActionTypes.FETCH_REQUEST] = (state, action) => statusLens.set('FETCHING')(state);
exports.methods[ActionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(documentsLens.modify(fp.function.compose(selectedDocumentsLens.set([]), reliablePartnerRootLens.set(action.payload.reliablePartner), requestToParticipantRootLens.set(action.payload.requestToParticipant), suitabilityRootLens.set(action.payload.suitability), tenderRootLens.set(action.payload.tender))), submittedLens.set(action.payload.submitted === undefined ? null : action.payload.submitted), hasApprovedLens.set(action.payload.submitted !== undefined), originalCompanyLens.set(action.payload.company), originalBusinessIdLens.set(action.payload.businessId), participantLens.set(action.payload.participant), statusLens.set('FETCHED'), modifyPartnerStatus(action.payload
    .reliablePartnerStatus))(state);
exports.methods[ActionTypes.FETCH_FAILED] = (state, action) => statusLens.set('FAILED')(state);
exports.methods[fileActionTypes.FETCH_REQUEST] = (state, action) => documentsLens.modify((documents) => {
    switch (action.extra) {
        case 'tender': {
            return tenderStatusLens.set('FETCHING')(documents);
        }
        case 'suitability': {
            return suitabilityStatusLens.set('FETCHING')(documents);
        }
        case 'reliablePartner': {
            return reliablePartnerFetchStatusLens.set('FETCHING')(documents);
        }
        case 'requestToParticipant': {
            return requestToParticipantStatusLens.set('FETCHING')(documents);
        }
    }
    return documents;
})(state);
exports.methods[fileActionTypes.FETCH_SUCCESS] = (state, action) => documentsLens.modify((documents) => {
    switch (action.extra) {
        case 'tender': {
            return fp.function.compose(tenderStatusLens.set('FETCHED'), tenderRootLens.set(action.payload.node), tenderLens.set(action.payload.files))(documents);
        }
        case 'suitability': {
            return fp.function.compose(suitabilityStatusLens.set('FETCHED'), suitabilityRootLens.set(action.payload.node), suitabilityLens.set(action.payload.files))(documents);
        }
        case 'reliablePartner': {
            return fp.function.compose(reliablePartnerFetchStatusLens.set('FETCHED'), reliablePartnerLens.set(action.payload.files))(documents);
        }
        case 'requestToParticipant': {
            return fp.function.compose(requestToParticipantStatusLens.set('FETCHED'), requestToParticipantRootLens.set(action.payload.node), requestToParticipantLens.set(action.payload.files))(documents);
        }
    }
    return documents;
})(state);
exports.methods[fileActionTypes.FETCH_FAILURE] = (state, action) => documentsLens.modify((documents) => {
    switch (action.extra) {
        case 'tender': {
            return tenderStatusLens.set('FAILED')(documents);
        }
        case 'suitability': {
            return suitabilityStatusLens.set('FAILED')(documents);
        }
        case 'requestToParticipant': {
            return requestToParticipantStatusLens.set('FAILED')(documents);
        }
    }
    return documents;
})(state);
exports.methods[ActionTypes.SUBMIT_REQUEST] = (state, action) => submitStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.SUBMIT_SUCCESS] = (state, action) => fp.function.flow(submitStatusLens.set('FETCHED'), submittedLens.set(Date.now()), originalCompanyLens.modify((original) => {
    const changed = changedCompanyLens.get(state);
    if (changed) {
        return changed;
    }
    return original;
}), originalBusinessIdLens.modify((original) => {
    const changed = changedBusinessIdLens.get(state);
    if (changed) {
        return changed;
    }
    return original;
}))(state);
exports.methods[ActionTypes.SUBMIT_FAILED] = (state, action) => submitStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.FETCH_NOTES_REQUEST] = (state, action) => listNotesStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.FETCH_NOTES_SUCCESS] = (state, action) => fp.function.compose(listNotesStatusLens.set('FETCHED'), notesLens.set(action.payload))(state);
exports.methods[ActionTypes.FETCH_NOTES_FAILED] = (state, action) => listNotesStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.ADD_NOTE_REQUEST] = (state, action) => addNoteStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.ADD_NOTE_SUCCESS] = (state, action) => addNoteStatusLens.set('FETCHED')(state);
exports.methods[ActionTypes.ADD_NOTE_FAILED] = (state, action) => addNoteStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.EDIT_NOTE_REQUEST] = (state, action) => editNoteStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.EDIT_NOTE_SUCCESS] = (state, action) => editNoteStatusLens.set('FETCHED')(state);
exports.methods[ActionTypes.EDIT_NOTE_FAILED] = (state, action) => editNoteStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.TOGGLE_DOCUMENTS] = (state, action) => documentsLens.modify(selectedDocumentsLens.modify((selected) => {
    if (action.payload.status) {
        return action.payload.items.reduce((acc, x) => {
            if (acc.findIndex((z) => z.id === x.id) === -1) {
                acc.push(x);
            }
            return acc;
        }, [...selected]);
    }
    return selected.reduce((acc, x) => {
        if (action.payload.items.findIndex((z) => z.id === x.id) === -1) {
            acc.push(x);
        }
        return acc;
    }, []);
}))(state);
exports.methods[ActionTypes.APPROVE_SECTION_REQUEST] = (state, action) => approveStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.APPROVE_SECTION_SUCCESS] = (state, action) => approveStatusLens.set('FETCHED')(state);
exports.methods[ActionTypes.APPROVE_SECTION_FAILED] = (state, action) => approveStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.DECLINE_SECTION_REQUEST] = (state, action) => declineStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.DECLINE_SECTION_SUCCESS] = (state, action) => declineStatusLens.set('FETCHED')(state);
exports.methods[ActionTypes.DECLINE_SECTION_FAILED] = (state, action) => declineStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.FETCH_FAILED] = (state, action) => statusLens.set('FAILED')(state);
exports.methods[ActionTypes.FETCH_PENDING_FILES_REQUEST] = (state, action) => documentsLens.modify((documents) => {
    switch (action.section) {
        case 'tender': {
            return uploadedTenderStatusLens.set('FETCHING')(documents);
        }
        case 'suitability': {
            return uploadedSuitabilityStatusLens.set('FETCHING')(documents);
        }
    }
    return documents;
})(state);
exports.methods[ActionTypes.FETCH_PENDING_FILES_SUCCESS] = (state, action) => documentsLens.modify((documents) => {
    const temp = action.payload.map((x) => (Object.assign(Object.assign({}, x), { customMeta: x.customMeta.reduce((acc, meta) => {
            if (meta.id !== undefined) {
                acc[meta.id] = meta.value;
            }
            return acc;
        }, {}) })));
    switch (action.section) {
        case 'tender': {
            return fp.function.compose(uploadedTenderStatusLens.set('FETCHED'), uploadedTenderLens.set(temp))(documents);
        }
        case 'suitability': {
            return fp.function.compose(uploadedSuitabilityStatusLens.set('FETCHED'), uploadedSuitabilityLens.set(temp))(documents);
        }
    }
    return documents;
})(state);
exports.methods[ActionTypes.FETCH_PENDING_FILES_FAILED] = (state, action) => documentsLens.modify((documents) => {
    switch (action.section) {
        case 'tender': {
            return uploadedTenderStatusLens.set('FAILED')(documents);
        }
        case 'suitability': {
            return uploadedSuitabilityStatusLens.set('FAILED')(documents);
        }
    }
    return documents;
})(state);
exports.methods[ActionTypes.REMOVE_FILE] = (state, action) => documentsLens.modify((documents) => {
    switch (action.section) {
        case 'tender': {
            return fp.function.compose(selectedDocumentsLens.set([]), removedTenderLens.modify((x) => action.payload.reduce((acc, item) => {
                if (acc.findIndex((x) => x.id === item.id) === -1) {
                    acc.push(item);
                }
                return acc;
            }, [...x])))(documents);
        }
        case 'suitability': {
            return fp.function.compose(selectedDocumentsLens.set([]), removedSuitabilityLens.modify((x) => action.payload.reduce((acc, item) => {
                if (acc.findIndex((x) => x.id === item.id) === -1) {
                    acc.push(item);
                }
                return acc;
            }, [...x])))(documents);
        }
    }
    return documents;
})(state);
exports.methods[ActionTypes.SET_OFFER_COMPANY_INFO] = (state, action) => fp.function.flow(changedCompanyLens.set(action.payload.company), changedBusinessIdLens.set(action.payload.businessId), hasApprovedLens.set(false))(state);
exports.methods[ActionTypes.TOGGLE_COMPANY_INFO_APPROVE] = (state) => hasApprovedLens.modify((status) => !status)(state);
exports.methods[ActionTypes.FETCH_RELIABLE_PARTNER_REPORT_REQUEST] = (state) => documentsLens.modify(reliablePartnerFetchStatusLens.set('FETCHING'))(state);
exports.methods[ActionTypes.FETCH_RELIABLE_PARTNER_REPORT_SUCCESS] = (state) => documentsLens.modify(reliablePartnerFetchStatusLens.set('FETCHED'))(state);
exports.methods[ActionTypes.FETCH_RELIABLE_PARTNER_REPORT_FAILURE] = (state, action) => {
    var _a, _b, _c, _d;
    return statusUpdateFailureLens.set(((_a = action.payload) === null || _a === void 0 ? void 0 : _a.type) === 'THROTTLED_ERROR'
        ? {
            type: (_b = action.payload) === null || _b === void 0 ? void 0 : _b.type,
            message: (_c = action.payload) === null || _c === void 0 ? void 0 : _c.error
        }
        : {
            type: 'FAILED',
            message: (_d = action.payload) === null || _d === void 0 ? void 0 : _d.type
        })(state);
};
exports.methods[ActionTypes.TOGGLE_MODAL] = (state) => isModalOpenLens.modify((status) => !status)(state);
exports.methods[ActionTypes.CLEAR] = (state, action) => (Object.assign({}, exports.initialState));
exports.methods[ActionTypes.UPDATE_RELIABLE_PARTNER_STATUS_SUCCESS] = (state, action) => modifyPartnerStatus(action.payload)(state);
exports.methods[ActionTypes.UPDATE_RELIABLE_PARTNER_STATUS_FAILURE] = (state, action) => statusUpdateFailureLens.set({
    type: 'FAILED',
    message: action.payload.error
})(state);
exports.methods[ActionTypes.GENERATE_REPORT_STATUS_SUCCESS] = (state, action) => fp.function.compose(reportFetchStatusLens.set('FETCHED'), reportParticipantUuidLens.set(action.payload.participantUuid))(state);
exports.methods[ActionTypes.GENERATE_REPORT_STATUS_FAILED] = (state, action) => fp.function.compose(reportFetchStatusLens.set('FAILED'), reportParticipantUuidLens.set(action.payload.participantUuid))(state);
exports.methods[ActionTypes.CLEAR_STATUS] = (state) => fp.function.flow(reportParticipantUuidLens.set(''), reportFetchStatusLens.set('STANDBY'), statusUpdateFailureLens.set({
    type: '',
    message: ''
}))(state);
const modifyPartnerStatus = (actionPayload) => {
    if (!actionPayload)
        return fp.function.identity;
    return fp.function.compose(partnerStatusValueLens.set(actionPayload.value), partnerStatusLastCheckedAtLens.set(actionPayload.lastCheckedAt), partnerStatusUpdatedAt.set(actionPayload.updatedAt), isStatusChangedLens.set(actionPayload.isStatusChanged), participantUuidLens.set(actionPayload.participantUuid));
};
//# sourceMappingURL=tender.js.map